import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/config/site";
import { Logo } from "@/components/landing/Logo";

export default function LegalPage() {
  const { doc } = useParams();
  const content = LEGAL[doc];

  return (
    <div className="min-h-screen bg-brand-paper">
      <header className="border-b border-brand-ink/10 bg-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" aria-label="Volver a la web"><Logo /></Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16" data-testid="legal-page">
        {content ? (
          <>
            <h1 className="font-display font-extrabold tracking-tight text-brand-ink text-3xl sm:text-4xl">{content.title}</h1>
            <div className="mt-8 space-y-5">
              {content.paragraphs.map((p, i) => (
                <p key={i} className="text-brand-ink/65 leading-relaxed">{p}</p>
              ))}
            </div>
          </>
        ) : (
          <h1 className="font-display font-extrabold text-brand-ink text-3xl">Documento no encontrado</h1>
        )}
        <Link to="/" data-testid="legal-back-link" className="mt-12 inline-flex items-center gap-2 font-display font-bold text-sm text-brand-ink bg-brand-yellow px-6 py-3 rounded-full hover:bg-brand-yellowhover transition-colors">
          <ArrowLeft size={16} /> Volver a la web
        </Link>
      </main>
    </div>
  );
}
